import PropTypes from 'prop-types';
import geolocShape from './geoloc';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    coords: geolocShape.isRequired,
  }),
);
